interface WfIconProps {
  name: 'upload' | 'loading' | 'file' | 'danger' | 'close';
  className?: string;
}

const uploadIcon = (
  <g stroke="none">
    <g transform="translate(-538.000000, -727.000000)">
      <g transform="translate(374.000000, 710.000000)">
        <g transform="translate(164.000000, 17.000000)">
          <rect opacity="0" x="0" y="0" width="24" height="24"></rect>
          <path d="M19,19.611 L5.00000001,19.611 C4.4475,19.611 4.00000001,19.161 4.00000001,18.606 L4.00000001,13.5815 L6.00000001,13.5815 L6.00000001,17.601 L18,17.601 L18,13.5815 L20,13.5815 L20,18.606 C20,19.161 19.5525,19.611 19,19.611 Z M15.297,8.331 L12.7585,8.331 L12.7585,14.3795 L10.7415,14.3795 L10.7415,8.331 L8.2035,8.331 C8.0235,8.331 7.9335,8.11399999 8.061,7.98700001 L11.6075,4.4415 C11.6865,4.36300001 11.814,4.36300001 11.8925,4.4415 L15.4395,7.98700001 C15.5665,8.11399999 15.4765,8.331 15.297,8.331 Z"></path>
        </g>
      </g>
    </g>
  </g>
);

const fileIcon = (
  <g stroke="none">
    <g transform="translate(-374.000000, -780.000000)">
      <g transform="translate(374.000000, 780.000000)">
        <rect opacity="0" x="0" y="0" width="24" height="24"></rect>
        <g transform="translate(3.339844, 2.905664)">
          <rect opacity="0" x="0" y="0" width="18.3076172" height="18.3076172"></rect>
          <path d="M5.47397754,6.08989809 L6.39851221,7.01443276 L3.62621589,9.78803677 C2.0530685,11.3598765 2.0530685,13.7634051 3.62621589,15.3365525 C5.19936328,16.9096999 7.6015842,16.9083922 9.1734239,15.3365525 L11.9470279,12.5629485 L12.8715626,13.4874831 L10.0979586,16.2610871 C8.06319768,18.295848 4.73513442,18.295848 2.70037354,16.2610871 C0.665612648,14.2263262 0.665612648,10.898263 2.70037354,8.8635021 L5.47397754,6.08989809 Z M5.47397754,6.08989809 L10.0979586,1.46460938 C11.6697983,-0.107230324 14.0733269,-0.107230324 15.6451666,1.46460938 C17.2170063,3.03644907 17.218314,5.43997768 15.6451666,7.01312507 L11.0238009,11.6371061 L10.0992663,10.7125714 L14.7219396,6.08989809 C15.73932,5.07251765 15.73932,3.40913987 14.7219396,2.39045173 C13.7045592,1.3717636 12.0411814,1.37437898 11.0238009,2.39045173 L6.39851221,7.01443276 L5.47397754,6.08989809 Z M7.32304687,7.93896743 L8.24888923,8.8635021 L5.47397754,11.6384138 C4.91951828,12.1941807 4.91951828,12.9330239 5.47397754,13.4887908 C6.02843679,14.0445577 6.76858762,14.0432501 7.32435456,13.4887908 L10.0966509,10.7138791 L11.0224932,11.6384138 L8.24888923,14.4133255 C7.23150879,15.4307059 5.56682331,15.4307059 4.54944287,14.4133255 C3.53206243,13.395945 3.53206243,11.7325672 4.54944287,10.7138791 L7.32435456,7.94158279 L7.32304687,7.93896743 Z M11.9470279,12.5629485 L15.1835531,9.32642327 C15.4607827,9.04919363 15.8308581,9.04919363 16.1080877,9.32642327 C16.3853174,9.6036529 16.3853174,9.9737283 16.1080877,10.2509579 L12.8715626,13.4874831 L11.9470279,12.5629485 L11.9470279,12.5629485 Z M7.32304688,7.93896743 L10.559572,4.70244224 C10.8381094,4.4252126 11.2068771,4.4252126 11.4841067,4.70244224 C11.762644,4.97967188 11.762644,5.34974727 11.4841067,5.62697691 L8.24888923,8.8635021 L7.32304688,7.93896743 Z"></path>
        </g>
      </g>
    </g>
  </g>
);

const dangerIcon = (
  <>
    <defs>
      <path
        d="M8,0 C3.584,0 0,3.584 0,8 C0,12.416 3.584,16 8,16 C12.416,16 16,12.416 16,8 C16,3.584 12.416,0 8,0 Z M8.8,12 L7.2,12 L7.2,10.4 L8.8,10.4 L8.8,12 Z M8.8,8.8 L7.2,8.8 L7.2,4 L8.8,4 L8.8,8.8 Z"
        id="path-danger"
      ></path>
    </defs>
    <g stroke="none">
      <g transform="translate(-1831.000000, -725.000000)">
        <g transform="translate(1831.000000, 489.000000)">
          <g transform="translate(0.000000, 236.000000)">
            <rect opacity="0" x="0" y="0" width="24" height="24"></rect>
            <g transform="translate(4.000000, 4.000000)">
              <use xlinkHref="#path-danger"></use>
            </g>
          </g>
        </g>
      </g>
    </g>
  </>
);

const closeIcon = (
  <>
    <defs>
      <polygon
        id="path-close"
        points="14 1.41 12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7"
      ></polygon>
    </defs>
    <g stroke="none">
      <g transform="translate(-1625.000000, -307.000000)">
        <g transform="translate(989.000000, 201.000000)">
          <g transform="translate(0.000000, 106.000000)">
            <g transform="translate(636.000000, 0.000000)">
              <g transform="translate(5.000000, 5.000000)">
                <mask fill="white">
                  <use xlinkHref="#path-close"></use>
                </mask>
                <use id="Color" xlinkHref="#path-close"></use>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </>
);

function WfIcon(props: WfIconProps & React.SVGProps<SVGSVGElement>) {
  const { name, className = '', ...prop } = props;

  const loadingIcon = <i className={`wf-upload-icon_loading ${className}`}></i>;
  if (name === 'loading') return loadingIcon;

  return (
    <svg {...prop} className={className} xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      {name === 'upload' && uploadIcon}
      {name === 'file' && fileIcon}
      {name === 'danger' && dangerIcon}
      {name === 'close' && closeIcon}
    </svg>
  );
}

export default WfIcon;
